export const getEnvVariable = (variableName, defaultValue = null) => {
  // Check window object first (runtime injection)
  if (typeof window !== "undefined" && window[variableName]) {
    return window[variableName];
  }

  // Check process.env second (build-time)
  if (typeof process !== "undefined" && process.env && process.env[variableName]) {
    return process.env[variableName];
  }

  // Return default value
  return defaultValue;
};

const configMap = {
  test: {
    PAYMENT_SERVICE_URL:
      "http://sandbox-payment-engine.playground.monnify.com/api/v1",
    SDK_URL: "http://sandbox-monnifysdk-v2.playground.monnify.com",
    providerCode: "71272",
  },
  playground: {
    PAYMENT_SERVICE_URL:
      "http://sandbox-payment-engine.playground.monnify.com/api/v1",
    SDK_URL: "https://sandbox-monnifysdk-v2.playground.monnify.com",
    providerCode: "71272",
  },
  staging: {
    PAYMENT_SERVICE_URL: "https://sandbox.staging.monnify.com/api/v1",
    SDK_URL: "https://sandbox.sdk.staging.monnify.com",
    providerCode: "81884",
  },
  production: {
    PAYMENT_SERVICE_URL: "https://sandbox.monnify.com/api/v1",
    SDK_URL: "https://sandbox.sdk.monnify.com",
    providerCode: "81884",
  },
  dev: {
    PAYMENT_SERVICE_URL: "http://localhost:9091/api/v1",
    SDK_URL: "http://localhost:5000",
    providerCode: "71272",
  },
};

const APP_ENV = getEnvVariable("REACT_APP_ENV", "dev");
const config =
  configMap[APP_ENV];

export default {
  // Add common config values here
  ...config,
};



// WEBPACK FOOTER //
// ./src/config.js